// extracted by mini-css-extract-plugin
module.exports = {"LanguageChart":"LanguageChart_LanguageChart__2BTCu","LanguageBox":"LanguageChart_LanguageBox__3AZ6i","Documents":"LanguageChart_Documents__1zZBb"};